import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'

export default function useServiceList() {
  const toast = useToast()

  const refServiceListTable = ref(null)
  const editServiceData = ref(null)

  const loadingServices = ref(false)
  const isAddNewServiceSidebarActive = ref(false)
  const isEditServiceSidebarActive = ref(false)

  const tableColumns = [
    { key: 'service', label: 'Service Name' },
    { key: 'classLabel', label: 'class' },
    { key: 'status' },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalServices = ref(1)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25]
  const services = ref()
  const fetchServices = () => {
    loadingServices.value = true
    store
      .dispatch('services/fetchServices')
      .then(response => {
        loadingServices.value = false
        totalServices.value = response.length
        services.value = response
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching Drivers list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    fetchServices()
    refServiceListTable.value.refresh()
  }

  const resolveServiceStatusVariant = status => {
    if (status === 'ACTIVE') return 'success'
    if (status === 'INACTIVE') return 'danger'
    return 'primary'
  }

  const statusOptions = {
    ACTIVE: { label: 'Active' },
    INACTIVE: { label: 'Inactive' },
  }

  function displayEditSideBar(service) {
    editServiceData.value = service
    isEditServiceSidebarActive.value = true
  }

  fetchServices()

  return {
    fetchServices,
    refetchData,
    isAddNewServiceSidebarActive,
    isEditServiceSidebarActive,
    tableColumns,
    loadingServices,
    refServiceListTable,
    statusOptions,
    editServiceData,
    displayEditSideBar,
    resolveServiceStatusVariant,
    services,
    perPage,
    totalServices,
    currentPage,
    perPageOptions,
  }
}
